import { useSuspenseQuery } from "@tanstack/react-query"

import { useClient } from "api"
import { FhirAddress } from "commons"
import { fhirAddressToIAddress } from "utils"

const useOrganizationInfo = (id: string) => {
  const { read } = useClient()
  const queryKey = ["practice-name", id]

  const { data: { orgName, orgAddress }, isLoading } = useSuspenseQuery({
    queryKey,
    queryFn: async () => {
      const { name, address } = await read<{ name: string; address: FhirAddress[] }>(`organizations/info/${id}`)
      const orgAddress = fhirAddressToIAddress(address)
        
      return { orgName: name, orgAddress }
    },
  })

  return { orgName, orgAddress, isLoading }
}

export { useOrganizationInfo }
